import { TGetDetalisId, TliveListType, TliveDetailsId, TliveDetailsType, TGetParentId, TliveMenuType, TGetUserCurrId, TUserCurrType, TLiveVideoType, TLiveVideoListType } from "@/module/live";
import request from "@/utils/requset";
import { TResponse, TTotal } from "@/module/common"
export const GetItemlist = () => { }

// 获取直播列表
export const getLiveList = (data: TGetDetalisId) => {
    return request < TGetDetalisId,TTotal<TliveListType[]>>({
        url: '/api/user/liveplaydirectory/getlastdiclistv2',
        method: 'GET',
        data
    })
}

// 直播详情页
export const getLiveDetails = (data: TliveDetailsId) => {
    return request<TliveDetailsId, TliveDetailsType>({
        url: '/api/user/livepagecontent/getlivepagecontentinfo',
        method: 'GET',
        data
    })
}

// 直播视频列表
export const getLiveVideolist = (data: TLiveVideoType) => {
    return request<TLiveVideoType, TLiveVideoListType[]>({
        url: '/api/user/livepagecontent/getslivepagelist',
        method: 'POST',
        data
    })
}

// 直播目录菜单页
export const getLiveMenu = (data: TGetParentId) => {
    return request<TGetParentId, TliveMenuType[]>({
        url: '/api/user/liveplaydirectory/getuserauthstrdiclist',
        method: 'GET',
        data
    })
}

// 首页直播列表
export const getLiveCurriculum = (data: TGetUserCurrId) => {
    return request<TGetUserCurrId, TTotal<TUserCurrType[]>>({
        url: '/api/user/liveplaydirectory/getusercurriculum',
        method: 'GET',
        data
    })
}